module.exports = __webpack_public_path__ + "static/img/logo(3).8a80007.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo(3).png
// module id = THNQ
// module chunks = 0